import React, { setGlobal } from "reactn";
import PropTypes from "prop-types";

//styled component
import NumberStyled from "./NumberInput.styled";

const NumberInput = props => {
    const { numberValue, values, min, max } = props;
    const increment = () => {
        if ((values[numberValue] || 0) <= (max || 99999)) {
            values[numberValue] = (values[numberValue] || 0) + 1;
            setGlobal({
                values: values
            });
        }
    }
    const decrement = () => {
        if ((values[numberValue] || 0) >= ((min + 1) || 1)) {
            values[numberValue] = (values[numberValue] || 0) - 1;
            setGlobal({
                values: values
            });
        }
    }

    return (
        <NumberStyled>
            <div className="input-group input-number-group">
                <div className="input-group-button">
                    <button className="input-number-decrement" onClick={decrement} aria-label="decrement">-</button>
                </div>
                <input className="input-number" type="number" value={values[numberValue] || 0} aria-label="quantity"></input>
                <div className="input-group-button">
                    <button className="input-number-increment" onClick={increment} aria-label="increment">+</button>
                </div>
            </div>
            {min &&
                <p>Min top-up €{min}.00</p>
            }

        </NumberStyled>
    );
}

// props validation
NumberInput.propTypes = {
    numberValue: PropTypes.string,
    values: PropTypes.object,
    min: PropTypes.number,
    max: PropTypes.number
};

export default NumberInput;
